import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Hey, listen up devs! AI is making some major waves and it's changing the game in a big way, even in the world of testing. That's why you gotta check out the AI in QA and Testing Summit - the go-to event for exploring the impact of AI on software testing.</p>
                            <p className="concept-text p1">This summit is all about the nitty-gritty details of AI in testing. We're talking about testing AI systems, identifying biases in AI-powered testing, using AI to level up continuous integration and delivery, and automating tests with the power of AI. Plus, we'll dive into the future of software testing with AI and what it means for us all.</p>
                            <p className="concept-text p1">Expert speakers will be dropping some serious knowledge bombs on how AI can enhance the quality of testing processes, predict software quality with machine learning, and even improve traditional testing roles and responsibilities. You won't wanna miss it!</p>
                            <p className="concept-text p1">Expect to walk away with a wealth of information on strategies, best practices, opportunities, challenges, benefits, and limitations of using AI in software testing. It's time to stay ahead of the curve, my friends. See you at the summit!</p>
                            <p className='concept-text concept-text--bold p1'>So, if you wanna <span>stay on top of the freshest AI tools</span> in QA and Testing, then you gotta hit up our conference</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;